import React, { Suspense } from 'react';
import { createBrowserHistory } from 'history';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { Box } from '@material-ui/core';
import MainTemplate from '../components/templates/MainTemplate';
import Login from '../pages/Login/Login';
import WysywygToHtml from '../components/atoms/WysywygToHtml/WysywygToHtml';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import Spin from '../components/atoms/Spin/Spin';
import { renderRouteList, routeList } from './route-list';

export const browserHistory = createBrowserHistory();

const Routes = ({ userPermissions, relogEnabled }: { userPermissions: string[], relogEnabled: boolean }) => {
    const privateRouteList = renderRouteList(routeList, userPermissions, relogEnabled);
    return (
        <Box position="relative" width="100%" height="100%" display="flex">
            <Router history={browserHistory}>
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/about" component={() => <WysywygToHtml url="about" />} />
                    <Route path="/conditions" component={() => <WysywygToHtml url="condition" />} />
                    <Route
                        path="/paymentAgreements"
                        component={() => <WysywygToHtml url="payment-agreements" />}
                    />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route
                        render={({ location }) => (
                            <MainTemplate location={location.key}>
                                <Suspense fallback={<Spin size={70} />}>
                                    <Switch location={location}>
                                        {privateRouteList}
                                        <Redirect to="/cabinet" />
                                    </Switch>
                                </Suspense>
                            </MainTemplate>
                        )}
                    />
                </Switch>
            </Router>
        </Box>
    );
};

export default Routes;
